module.exports = __webpack_public_path__ + "img/CEDI.869ea1ec.svg";